<template>
  <div>
    <iframe
      frameborder="no"
      scrolling="no"
      width="186"
      height="186"
      :src="loginUrl"
      id="weworkFrame"
      @load="onLoad()"
    ></iframe>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loginUrl: null
    };
  },
  mounted() {
    var me = this;
    me.loginUrl = me.$url.api + "/api/qywx/qr_login";
  },
  methods: {
    onLoad() {
      this.listenOnMessage();
    },
    listenOnMessage() {
      var me = this,
        $frame = document.getElementById("weworkFrame");

      if (!me.hasListener) {
        me.hasListener = true;
        window.addEventListener("message", me.authCallback, false);
      }

      if ($frame.contentWindow && $frame.contentWindow.postMessage) {
        // 使用postMessage方式，而不是redirect
        $frame.contentWindow.postMessage("ask_usePostMessage", "*");
      }
    },
    authCallback(event) {
      var me = this,
        $frame = document.getElementById("weworkFrame");
      me.$store.state.isloading = true;
      me.$ajax({
        url: event.data,
        method: "post"
      }).then(resp => {
        me.$store.state.isloading = false;
        var res = resp.data;
        if (res.success) {
          me.$message.success("登录成功");
          me.$emit("login", res.data);
        } else {
          if (res.code == 301) {
            // 跳转信息完善页面
            window.location.href = res.message;
          } else if (res.code == 100001) {
            // 跳转企业注册
            me.$confirm("您的公司还未注册华商云服, 是否注册?", "提示", {
              confirmButtonText: "我要注册",
              cancelButtonText: "取消",
              type: "warning"
            })
              .then(() => {
                me.$emit("register");
              })
              .catch(() => {
                $frame.src = me.loginUrl;
              });
          } else {
            $frame.src = me.loginUrl;
            me.$message.error(res.message);
          }
        }
      });
    }
  },
  beforeDestroy() {
    var me = this;
    if (me.hasListener) {
      window.removeEventListener("message", me.authCallback, false);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/qywx/login.vue